export default __webpack_public_path__ + "static/media/2.74dae968.jpg";